import CodeUtil from "@plannel/pages/utils/code-util";

/*
 * DW 대시보드 공용 값 포맷터.
 */

// 금액 포맷터 — currencyCd 있으면 통화기호(CodeUtil.getCurrencySymbol), 없으면 사용자 통화기호로 폴백.
// 금액은 항상 통화기호와 함께 표기(PlanNEL 규칙). T/B/M/K 축약.
export const makeFmtMoney = (currencyCd) => {
  const userData = JSON.parse(localStorage.getItem("user"));
  const s = currencyCd ? CodeUtil.getCurrencySymbol(currencyCd) : (userData?.currencySymbol ?? "$");
  return (v) => {
    /*
     * ★ 부호는 **통화기호 앞**이다 — `-₩4.5B`. 절대값을 포맷한 뒤 부호를 붙인다.
     *   예전엔 음수를 그대로 넣어 `₩-4.5B` 가 나왔다(기호와 숫자 사이에 마이너스가 끼는 모양).
     *   양수만 쓰는 화면은 결과가 달라지지 않는다.
     */
    const n = Number(v) || 0;
    const sign = n < 0 ? "-" : "";
    const a = Math.abs(n);
    if (a >= 1e12) return `${sign}${s}${(a / 1e12).toFixed(1)}T`;
    if (a >= 1e9) return `${sign}${s}${(a / 1e9).toFixed(1)}B`;
    // ★ M 도 소수 1자리 — 0자리면 1.4M 과 1.9M 이 똑같이 "1M" 이 된다.
    //   업무 금액이 가장 많이 몰리는 구간이라 여기서 해상도를 잃으면 표의 숫자들이 서로 안 맞아 보인다
    //   (계획 ₩1M / 실적 ₩2M / 편차 +₩476K). T·B 와도 자릿수가 안 맞았다.
    if (a >= 1e6) return `${sign}${s}${(a / 1e6).toFixed(1)}M`;
    if (a >= 1e3) return `${sign}${s}${(a / 1e3).toFixed(0)}K`;
    return `${sign}${s}${Math.round(a)}`;
  };
};

// 수량 포맷터 — 통화기호 없이 M/K 축약.
export const fmtQty = (v) => {
  if (Math.abs(v) >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  if (Math.abs(v) >= 1e3) return `${(v / 1e3).toFixed(0)}K`;
  return `${Math.round(v).toLocaleString()}`;
};

/*
 * 축약하지 않는 수량 — **비율의 근거로 읽히는 수**에 쓴다(분모, 또는 분자/분모 쌍).
 *
 * 🚨 `fmtQty` 를 분모에 쓰면 카드가 자기 모순이 된다 — 정시율 37.2% 옆에 "509 / 1K" 가 붙으면
 *   보이는 두 수로 검산했을 때 50.9% 가 나온다(실제 분모는 1,369). 큰 수를 한눈에 보라는 축약과
 *   검산의 근거가 되는 수는 **성격이 다르다**. 단독 수량(총 출하량 59K 같은)은 그대로 `fmtQty`.
 */
export const fmtExact = (v) => `${Math.round(Number(v) || 0).toLocaleString()}`;
